import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutSettlement401kTable extends Layout {
    sourceDrs401kHist: DataSource;
    table401kDetails: Table;
}
